import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-blank",
  "use": "icon-close-blank-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 17\" id=\"icon-close-blank\"><path fill=\"#fff\" d=\"M0 .5h16v16H0z\" opacity=\".01\" /><path fill=\"#000\" fill-opacity=\".65\" fill-rule=\"evenodd\" d=\"M2.706 2.5 2 3.206 7.294 8.5 2 13.794l.706.706L8 9.206l5.294 5.294.706-.706L8.706 8.5 14 3.206l-.706-.706L8 7.794z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol